import React from 'react';
import { withTheme } from 'styled-components';
export var CapitalRiesgoIcon = function CapitalRiesgoIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "259px",
    height: "260px",
    viewBox: "0 0 259 260",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Capital riesgo"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    id: "Capital-riesgo",
    transform: "translate(-53.000000, -6.000000)",
    stroke: theme.colors.primary,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "13"
  }, React.createElement("g", {
    id: "Capital_riesgo",
    transform: "translate(59.000000, 13.000000)"
  }, React.createElement("g", {
    id: "Money-Payments-Finance__x2F__Currencies__x2F__currency-euro-increase"
  }, React.createElement("g", {
    id: "Group_74"
  }, React.createElement("g", {
    id: "currency-euro-increase"
  }, React.createElement("path", {
    d: "M16.58,245.94 L105.96,166.49 C109.85,163.04 115.66,162.89 119.73,166.14 L158.88,197.46 C163.02,200.77 168.96,200.54 172.84,196.93 L246.18,128.48",
    id: "Shape_573"
  }), React.createElement("polyline", {
    id: "Shape_574",
    points: "203.43 128.47 246.15 128.47 246.15 171.19"
  }), React.createElement("path", {
    d: "M48.7,171.27 C-34.19,127.15 -3.18,0.32 91.33,0.32 C125.22,0.39 156.26,19.31 171.84,49.4 C187.43,79.5 184.97,115.76 165.46,143.48",
    id: "Shape_575"
  }), React.createElement("line", {
    x1: "43.25",
    y1: "107.11",
    x2: "96.65",
    y2: "107.11",
    id: "Shape_576"
  }), React.createElement("line", {
    x1: "43.25",
    y1: "85.76",
    x2: "96.65",
    y2: "85.76",
    id: "Shape_577"
  }), React.createElement("path", {
    d: "M112.86,42.83 C86.48,43.22 65.31,64.72 65.31,91.09 C65.31,117.46 86.49,138.96 112.86,139.35",
    id: "Shape_578"
  })))))), React.createElement("g", {
    id: "Energi\u0301a",
    transform: "translate(241.000000, 6.000000)"
  })));
};
export default withTheme(CapitalRiesgoIcon);